// create a document and pipe to a blob
import React from 'react';
import ReactDOM from 'react-dom';

import * as html2canvas from 'html2canvas';
import { mapStore } from 'stores/MapStore';
import { reportStore } from 'stores/ReportStore';
import { criteriaStore } from 'stores/CriteriaStore';

import standardsConfig from 'js/standards.config';

import { reportActions } from 'actions/ReportActions';

import PrintTask from 'esri/tasks/PrintTask';
import PrintParameters from 'esri/tasks/PrintParameters';
import PrintTemplate from 'esri/tasks/PrintTemplate';
import esriRequest from 'esri/request';

import _ from 'lodash';
import { Promise as bbPromise } from 'promise';

import { config } from 'js/config/config';
import { snowLoadText } from 'js/config/text.config';
import { BaseGenerator as base_pdf } from 'utils/pdfUtils/BaseGenerator';
import { GenerateTable } from 'utils/pdfUtils/GenerateTable';
import { GenerateTornadoTable } from './pdfUtils/GenerateTornadoTable';
import { GenerateDetails } from 'utils/pdfUtils/GenerateDetails';
import Table from '../components/Report/Table';

let start = 50;
let start_top = 40;
let col_1_4 = start;
let col_2_4 = 190;
let col_3_4 = 330;
let col_4_4 = 420;
let col_1_2 = start;
let col_2_2 = start + 260;
let row_home_1 = 80;
let row_1 = 110;
let row_1_img = row_1 + 35;
let row_1_content = row_1 + 215;
let row_2 = 430;
let row_2_img = row_2 + 30;
let row_2_content = row_2 + 215;
let h1 = 18;
let h2 = 15;
let h3 = 13.5;
let h4 = 12;
let p = 10;
let break_line = 560;
let download_icon_x = 495;
let print_icon_x = 535;
let width_logo = 90;
let width_map = 250;
let width_icon = 25;
let report_row_1 = 330;
let report_row_2 = report_row_1 + 100;
let report_row_3 = report_row_1 + 200;
let report_map = 230;
let x = 'XXXXX';
let page_num_x = 500;
let page_num_y = 750;

let loadPageHeight = 700;
let rowHeight = 15;
let resultsIndent = 25;
let dateAccessed = new Date();
let resultsYValue = col_2_4 + 15;

let logoImg = base_pdf.logo;

let localMap = '';
let regionalMap = '';
let floodMap = '';
let tornadoTable = '';

// Appropriate URL - removes the GUID that persists
const shareURL = window.location.protocol + '//' + window.location.host + window.location.pathname;

const fullReportBuilder = {
  buildReport: (loginInfo) => {
    // turn off layers
    let loads = reportStore.getState().loads;
    _.forEach(loads, (load) => {
      load.visible = false;
    });

    function toDataUrl(url) {
      return new bbPromise((resolve) => {
        let image = new Image();
        image.onload = function () {
          var canvas = document.createElement('canvas');
          canvas.width = this.naturalWidth; // or 'width' if you want a special/scaled size
          canvas.height = this.naturalHeight; // or 'height' if you want a special/scaled size
          canvas.getContext('2d').drawImage(this, 0, 0);
          // ... or get as Data URI
          resolve(canvas.toDataURL('image/png'));
        };
        image.setAttribute('crossOrigin', 'anonymous');
        image.src = url;
      });
    }

    let { map, basemapGallery } = mapStore.getState();

    let details = criteriaStore.getState();
    map.centerAt([details.longitude, details.latitude]).then(() => {
      _.forEach(map.layerIds, (id) => {
        if (_.includes(id, 'layer' === false)) {
          map.getLayer(id).hide();
        }
      });

      // let mapUrl = 'https://gis.asce.org/arcgis/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task';
      // let mapUrl =
      //   'https://ags107.blueraster.io/server/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task';
      let mapUrl =
        'https://utility.arcgisonline.com/arcgis/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task';

      let localMapPrintTemplate = new PrintTemplate();
      localMapPrintTemplate.format = 'PNG32';
      localMapPrintTemplate.layout = 'MAP_ONLY';
      localMapPrintTemplate.preserveScale = true;
      localMapPrintTemplate.outScale = 20000;
      localMapPrintTemplate.showAttribution = false;
      localMapPrintTemplate.exportOptions = {
        width: 500,
        height: 500,
        dpi: 96,
      };

      let localMapParams = new PrintParameters();
      localMapParams.map = map;
      localMapParams.template = localMapPrintTemplate;
      let localMapRequest = new PrintTask(mapUrl);

      let regionalMapPrintTemplate = new PrintTemplate();
      regionalMapPrintTemplate.format = 'PNG32';
      regionalMapPrintTemplate.layout = 'MAP_ONLY';
      regionalMapPrintTemplate.preserveScale = true;
      regionalMapPrintTemplate.outScale = 400000;
      regionalMapPrintTemplate.showAttribution = false;
      regionalMapPrintTemplate.exportOptions = {
        width: 500,
        height: 500,
        dpi: 96,
      };

      let regionalMapParams = new PrintParameters();
      regionalMapParams.map = map;
      regionalMapParams.template = regionalMapPrintTemplate;
      let regionalMapRequest = new PrintTask(mapUrl);

      let tsunamiMapPrintTemplate = new PrintTemplate();
      tsunamiMapPrintTemplate.format = 'PNG32';
      tsunamiMapPrintTemplate.layout = 'MAP_ONLY';
      tsunamiMapPrintTemplate.preserveScale = true;
      tsunamiMapPrintTemplate.outScale = 10000;
      tsunamiMapPrintTemplate.showAttribution = false;
      tsunamiMapPrintTemplate.exportOptions = {
        width: 500,
        height: 500,
        dpi: 96,
      };

      let tsunamiMapParams = new PrintParameters();
      tsunamiMapParams.map = map;
      tsunamiMapParams.template = tsunamiMapPrintTemplate;
      let tsunamiMapRequest = new PrintTask(mapUrl);

      const floodLayer = map.getLayer('Flood');
      if (floodLayer) {
        map.getLayer('Flood').hide();
      }

      esriRequest.setRequestPreCallback((ioArgs) => {
        return ioArgs;
      });

      const updateIOArgs = (url) => {
        esriRequest.setRequestPreCallback((ioArgs) => {
          if (ioArgs.content && ioArgs.content.Web_Map_as_JSON) {
            let webmap = JSON.parse(ioArgs.content.Web_Map_as_JSON);

            const basemap = webmap.operationalLayers.find((layer) => {
              return layer.id !== 'map_graphics';
            });
            basemap.url = url;
            delete basemap.type;
            delete basemap.imageData;

            const graphics = webmap.operationalLayers.find((layer) => {
              return layer.id === 'map_graphics';
            });
            webmap.operationalLayers = [basemap, graphics];

            ioArgs.content.Web_Map_as_JSON = JSON.stringify(webmap);
          }
          return ioArgs;
        });
      };

      let localRetries = 0;
      const getLocalMap = () => {
        return new bbPromise((resolve, reject) => {
          updateIOArgs('https://services.arcgisonline.com/arcgis/rest/services/USA_Topo_Maps/MapServer');
          localMapRequest
            .execute(localMapParams)
            .then((results) => {
              toDataUrl(results.url).then((dataUrl) => {
                localMap = dataUrl;
                resolve();
              });
            })
            .catch((error) => {
              if (localRetries >= 3) {
                resolve();
                return;
              }
              localRetries += 1;
              getLocalMap().then(() => {
                resolve();
              });
            });
        });
      };

      let regionalRetries = 0;
      const getRegionalMap = () => {
        return new bbPromise((resolve, reject) => {
          updateIOArgs('https://services.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer');
          regionalMapRequest
            .execute(regionalMapParams)
            .then((results) => {
              toDataUrl(results.url).then((dataUrl) => {
                regionalMap = dataUrl;
                resolve();
              });
            })
            .catch((error) => {
              if (regionalRetries >= 3) {
                resolve();
                return;
              }
              regionalRetries += 1;
              getRegionalMap().then(() => {
                resolve();
              });
            });
        });
      };

      let floodRetries = 0;
      const getFloodMap = () => {
        return new bbPromise((resolve, reject) => {
          updateIOArgs('https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer');
          map.getLayer('Flood').show();
          tsunamiMapRequest
            .execute(tsunamiMapParams)
            .then((results) => {
              toDataUrl(results.url).then((dataUrl) => {
                floodMap = dataUrl;
                resolve();
              });
            })
            .catch((error) => {
              if (floodRetries >= 3) {
                resolve();
                return;
              }
              floodRetries += 1;
              getFloodMap().then(() => {
                resolve();
              });
            });
          map.getLayer('Flood').hide();
        });
      };

      let tornadoRetries = 0;
      const getTornadoTable = (tornadoDetails) => {
        return new bbPromise((resolve, reject) => {
          const table = <Table {...tornadoDetails} />;
          const tableDomRef = document.getElementById('tornado-table-hidden');
          ReactDOM.render(table, tableDomRef);

          html2canvas(tableDomRef, {
            width: 450,
            onclone: function (clone) {
              const clonedTableRef = clone.getElementById('tornado-table-hidden');
              clonedTableRef.style.display = 'block';
            },
          })
            .then((canvas) => {
              var dataURL = canvas.toDataURL();
              tornadoTable = dataURL;
              resolve();
            })
            .catch(() => {
              if (tornadoRetries >= 3) {
                resolve();
                return;
              }
              tornadoRetries += 1;
              getTornadoTable(tornadoDetails).then(() => {
                resolve();
              });
            });
        });
      };

      const promises = [getLocalMap(), getRegionalMap()];
      _.forEach(loads, (load) => {
        if (load.label === 'Flood' && load.checked === 'checked') {
          promises.push(getFloodMap());
        }
        if (load.label === 'Tornado' && load.checked === 'checked') {
          const tornadoDetails = load.details.find((detail) => detail.type === 'table');
          if (tornadoDetails) {
            promises.push(getTornadoTable(tornadoDetails));
          }
        }
      });

      bbPromise.all(promises).then(() => {
        esriRequest.setRequestPreCallback((ioArgs) => {
          return ioArgs;
        });
        fullReportBuilder.addSections(loginInfo);
      });
    });
  }, // end buildReport

  addSections: (loginInfo) => {
    let doc = new PDFDocument({
      bufferPages: true,
      margins: {
        top: 50,
        left: 50,
        right: 50,
        bottom: 15,
      },
    });
    let stream = doc.pipe(blobStream());

    // Metadata
    doc.info.Title = 'ASCE Report';
    doc.info.Author = 'Blue Raster';

    //Add details
    fullReportBuilder.addDetails(doc);

    //at this point the details have a set height, 360

    // Add Loads
    fullReportBuilder.addLoads(doc, 420, loginInfo);

    // Add Headers
    fullReportBuilder.addHeaders(doc);
    // add Page Numbers
    fullReportBuilder.addPageNumbers(doc);

    // end and display the document in the iframe to the right
    doc.end();
    reportActions.togglePreloader(false);
    stream.on('finish', () => {
      saveAs(stream.toBlob('application/pdf'), 'ASCEDesignHazardsReport.pdf');
    });
  }, // end addSections

  /**
   * Add text to doc
   * @returns updated Y position based on text height
   */
  addTextToDoc: (doc, text, xPosition, yPosition) => {
    const textHeight = doc.heightOfString(text);

    if (textHeight + yPosition > loadPageHeight) {
      doc.addPage();
      yPosition = row_home_1;
    }

    doc.text(text, xPosition, yPosition);

    const updatedYPosition = yPosition + textHeight;
    return updatedYPosition;
  },

  addLoads: (doc, firstPageStartHeight, loginInfo) => {
    loginInfo.loggedIn = true;
    // determine which loads to add
    let loadsToAdd = _.filter(reportStore.getState().loads, {
      checked: 'checked',
      showInReport: true,
    });

    // check for logged in
    if (!loginInfo.loggedIn) {
      loadsToAdd = _.filter(loadsToAdd, (load) => {
        return load.label === 'Tsunami' || load.label === 'Rain';
      });
    }

    let currentYValue = firstPageStartHeight;
    _.forEach(loadsToAdd, (load) => {
      if (fullReportBuilder.calcMaxHeight(load) + currentYValue > loadPageHeight) {
        doc.addPage();
        currentYValue = row_home_1;
      }
      fullReportBuilder.addLoad(load, doc, currentYValue);
      currentYValue = currentYValue + fullReportBuilder.calcMaxHeight(load);
    });

    //needs starting height
    if (currentYValue + 200 > loadPageHeight) {
      currentYValue = row_home_1;
      doc.addPage();
    }
    fullReportBuilder.addDisclaimer(doc, currentYValue);
  }, // end addLoads

  calcMaxHeight: (load) => {
    let details = criteriaStore.getState();

    let hawaii = false;
    if (
      (details.longitude >= 172 && details.longitude <= 180) ||
      (details.longitude < -176 && details.longitude > -180)
    ) {
      hawaii = true;
    }

    let defaultHeight = 0;
    switch (load.label) {
      case 'Ice':
        defaultHeight = 210;
        if (load.details.length > 3) {
          defaultHeight += 35;
        }
        return defaultHeight;

      case 'Snow':
        defaultHeight = 160;
        if (_.includes(load.sampleData.value[0].toLowerCase(), 'case study')) {
          defaultHeight += 120;
        }
        if (hawaii) {
          defaultHeight += 35;
        }
        if (typeof load.details[1] === 'object') {
          defaultHeight += 35;
        }
        _.forEach(load.details, (detail) => {
          if (detail.hasOwnProperty('label') && detail.label === 'Load') {
            defaultHeight += 35;
          }

          if (detail.type === 'note' && detail.note === snowLoadText.ELEVATION_NOTE) {
            defaultHeight += 100;
          }
        });
        if (load.details.find((detail) => detail.label === 'Ground Snow Loads for IRC only')) {
          defaultHeight += 35;
        }

        return defaultHeight;

      case 'Rain':
        defaultHeight = 225;
        if (load.details[0].value === 'No Data') {
          defaultHeight += 35;
        }
        return defaultHeight;
      case 'Wind':
        return 180;
      case 'Flood':
        return floodMap === '' ? 220 : 440;
      // return 440;
      case 'Tsunami':
        return 135;
      case 'Seismic':
        return 600;
      default:
        return 300;
    }
  }, // end calcMaxHeight

  addLoad: (load, doc, startingHeight) => {
    switch (load.label) {
      case 'Ice':
        fullReportBuilder.addIce(load, doc, startingHeight);
        break;
      case 'Snow':
        fullReportBuilder.addSnow(load, doc, startingHeight);
        break;
      case 'Rain':
        fullReportBuilder.addRain(load, doc, startingHeight);
        break;
      case 'Wind':
        fullReportBuilder.addWind(load, doc, startingHeight);
        break;
      case 'Flood':
        fullReportBuilder.addFlood(load, doc, startingHeight);
        break;
      case 'Tsunami':
        fullReportBuilder.addTsunami(load, doc, startingHeight);
        break;
      case 'Seismic':
        fullReportBuilder.addSeismic(load, doc, startingHeight);
        break;
      case 'Tornado':
        fullReportBuilder.addTornado(load, doc, startingHeight);
        break;
      default:
        break;
    }
  }, // end addLoad

  addHeaders: (doc) => {
    var range = doc.bufferedPageRange();
    for (var i = range.start; i < range.count; i++) {
      doc.switchToPage(i);
      doc.image(logoImg, start, start_top, { width: width_logo });
      // doc.image(downloadImg, download_icon_x, start_top, {width: width_icon});
      // doc.image(printImg, print_icon_x, start_top, {width: width_icon});
    }
  }, // end addHeaders

  addPageNumbers: (doc) => {
    const range = doc.bufferedPageRange();
    for (var i = range.start; i < range.count; i++) {
      doc.switchToPage(i);
      //get number of pages, cycle through them, add page
      doc.fontSize(8).text('Page ' + (i + 1) + ' of ' + range.count, 280, page_num_y);
      doc.fillColor('#0645AD').text(shareURL, 50, page_num_y, { link: shareURL, underline: true }).fillColor('black');
      const date = new Date();
      doc.text(date.toDateString(), 470, page_num_y);
    }
  },

  addDisclaimer: (doc, startingHeight) => {
    doc.lineWidth(1);
    doc.lineCap('butt').moveTo(col_1_4, startingHeight).lineTo(break_line, startingHeight).stroke();
    doc.fontSize(8);
    doc
      .text(
        'The ASCE Hazard Tool is provided for your convenience, for informational purposes only, and is provided “as is” and without warranties of any kind. The location data included herein has been obtained from information developed, produced, and maintained by third party providers; or has been extrapolated from maps incorporated in the ASCE standard. While ASCE has made every effort to use data obtained from reliable sources or methodologies, ASCE does not make any representations or warranties as to the accuracy, completeness, reliability, currency, or quality of any data provided herein. Any third-party links provided by this Tool should not be construed as an endorsement, affiliation, relationship, or sponsorship of such third-party content by or from ASCE.',
        start,
        startingHeight + rowHeight
      )
      .moveDown()
      .text(
        'ASCE does not intend, nor should anyone interpret, the results provided by this Tool to replace the sound judgment of a competent professional, having knowledge and experience in the appropriate field(s) of practice, nor to substitute for the standard of care required of such professionals in interpreting and applying the contents of this Tool or the ASCE standard.'
      )
      .moveDown()
      .text(
        'In using this Tool, you expressly assume all risks associated with your use. Under no circumstances shall ASCE or its officers, directors, employees, members, affiliates, or agents be liable to you or any other person for any direct, indirect, special, incidental, or consequential damages arising from or related to your use of, or reliance on, the Tool or any information obtained therein. To the fullest extent permitted by law, you agree to release and hold harmless ASCE from any and all liability of any nature arising out of or resulting from any use of data provided by the ASCE Hazard Tool.'
      );
  }, // end addDisclaimer

  addDetails: (doc) => {
    let detailsdoc = new GenerateDetails(doc, localMap, regionalMap);
    doc = detailsdoc.doc;
  }, // end addDetails

  addSeismic: (load, doc, startingHeight) => {
    let standardsVersion = criteriaStore.getState().standardsVersion;
    let soilClass = criteriaStore.getState().soilClass;
    let soilClassLabel = standardsConfig[standardsVersion].soilClassText[soilClass];

    // 3 possible cases - Not available, manual analysis, or normal analysis
    if (load.sampleData.value[0] === 'Not available with criteria selected.') {
      // not available case
      return;
    } else if (
      (standardsVersion === '7-10' && parseInt(soilClass) === 5) ||
      (standardsVersion === '7-16' && parseInt(soilClass) === 7)
    ) {
      // manual analysis case
      doc
        .font('Helvetica')
        .text(
          `A site response analysis shall be performed in accordance with ASCE/SEI ${standardsVersion} Section 21.1 for structures on Site Class F sites. If your structure is exempted under ASCE/SEI ${standardsVersion} Section 20.3.1, select a substitute site class.`,
          start + resultsIndent,
          startingHeight + rowHeight * 4
        );
      doc.fontSize(h2).font('Helvetica-Bold').text(load.label, col_1_4, startingHeight).font('Helvetica');
      doc.lineWidth(1);
      doc
        .lineCap('butt')
        .moveTo(col_1_4, startingHeight + 20)
        .lineTo(break_line, startingHeight + 20)
        .stroke();
      doc.fontSize(p).moveDown();
      startingHeight = startingHeight + 30;
      doc
        .font('Helvetica-Bold')
        .text('Site Soil Class: ', start, startingHeight)
        .text('Results: ', start, startingHeight + rowHeight)
        .text('Data Source: ', start, startingHeight + rowHeight * 5)
        .text('Date Accessed: ', start, startingHeight + rowHeight * 6);
      doc.font('Helvetica').text(soilClassLabel, resultsYValue, startingHeight);
      doc
        .fillColor('#0645AD')
        .text('USGS Seismic Design Maps', resultsYValue, startingHeight + rowHeight * 5, {
          link: config.links.seismicDesignLink,
          underline: true,
        })
        .fillColor('black');
      doc.text(dateAccessed.toDateString(), resultsYValue, startingHeight + rowHeight * 6);
    } else {
      // normal analysis
      if (
        _.some(load.details, {
          label: 'Note',
          type: 'singleLine',
          value: 'Ground motion hazard analysis may be required. See ASCE/SEI 7-16 Section 11.4.8.',
        })
      ) {
        // seismic repsonse contained nulls
        let sItems;
        load.details.map((detail) => {
          if (detail.hasOwnProperty('items')) {
            sItems = detail.items;
          }
        });

        const { coefficients } = standardsConfig[standardsVersion];

        let row_height_multiplier = 4;
        let generated_table = new GenerateTable(doc, sItems, coefficients, startingHeight);
        doc = generated_table.doc;

        doc.fontSize(h2).font('Helvetica-Bold').text(load.label, col_1_4, startingHeight).font('Helvetica');
        doc.lineWidth(1);
        doc
          .lineCap('butt')
          .moveTo(col_1_4, startingHeight + 20)
          .lineTo(break_line, startingHeight + 20)
          .stroke();
        doc.fontSize(p).moveDown();
        startingHeight = startingHeight + 30;
        doc
          .font('Helvetica-Bold')
          .text('Site Soil Class: ', start, startingHeight)
          .text('Results: ', start, startingHeight + rowHeight)
          .text('Data Accessed: ', start, startingHeight + rowHeight * 11)
          .text('Date Source: ', start, startingHeight + rowHeight * 12);

        doc.font('Helvetica').text(soilClassLabel, resultsYValue, startingHeight);
        doc
          .fillColor('#0645AD')
          .text('USGS Seismic Design Maps', resultsYValue, startingHeight + rowHeight * 12, {
            link: config.links.seismicDesignLink,
            underline: true,
          })
          .fillColor('black');
        doc.text(
          'Ground motion hazard analysis may be required. See ASCE/SEI 7-16 Section 11.4.8.',
          start,
          startingHeight + rowHeight * 10
        );
        doc.text(dateAccessed.toDateString(), resultsYValue, startingHeight + rowHeight * 11);
      } else {
        let generated_table;
        let targetLoad;

        if (standardsVersion === '41-17' || standardsVersion === '41-23') {
          const hazardLevels = [
            'Hazard Level BSE-2N',
            'Hazard Level BSE-1N',
            'Hazard Level BSE-2E',
            'Hazard Level BSE-1E',
            'TL Data',
          ];

          let currentStartingHeight = startingHeight;

          hazardLevels.forEach((hazardLevel) => {
            const hazardLevelDetail = load.details.find((detail) => detail.label === hazardLevel);
            if (hazardLevelDetail) {
              const coefficientsHazardLevel = hazardLevelDetail.items.map((item) => ({
                label: item.label,
                value: null,
              }));

              if (hazardLevelDetail && coefficientsHazardLevel) {
                targetLoad = hazardLevelDetail;

                doc
                  .font('Helvetica-Bold')
                  .text(`${hazardLevelDetail.label}: `, start, currentStartingHeight + start_top + rowHeight);
                doc.font('Helvetica');

                generated_table = new GenerateTable(
                  doc,
                  hazardLevelDetail.items,
                  coefficientsHazardLevel,
                  currentStartingHeight
                );

                currentStartingHeight = generated_table.endTableY - 60;

                if (standardsVersion === '41-17' && hazardLevel === 'Hazard Level BSE-2N') {
                  currentStartingHeight += 185;
                }
              }
            }
          });
        } else {
          const { coefficients } = standardsConfig[standardsVersion];

          let sItems;
          load.details.map((detail) => {
            if (detail.hasOwnProperty('items')) {
              sItems = detail.items;
            }
          });

          generated_table = new GenerateTable(doc, sItems, coefficients, startingHeight);
          doc = generated_table.doc;

          targetLoad = load.details.find((detail) => detail.label === 'Seismic Design Category');

          if (targetLoad && generated_table) {
            // Seismic Design Category
            doc.font('Helvetica-Bold').text('Seismic Design Category:', start, generated_table.endTableY);
            doc
              .font('Helvetica')
              .text(
                targetLoad.value,
                start + doc.font('Helvetica-Bold').widthOfString('Seismic Design Category: '),
                generated_table.endTableY
              );
          }
        }

        doc.font('Helvetica');

        // Array of base64 Chartjs images
        const chartImages = fullReportBuilder.getLoadChartImages(load);

        if (standardsVersion === '41-23') {
          fullReportBuilder.addCharts(doc, startingHeight + 40, chartImages, load);
        } else {
          fullReportBuilder.addCharts(doc, startingHeight - 15, chartImages, load);
        }

        doc.fontSize(h2).font('Helvetica-Bold').text(load.label, col_1_4, startingHeight).font('Helvetica');
        doc.lineWidth(1);
        doc
          .lineCap('butt')
          .moveTo(col_1_4, startingHeight + 30)
          .lineTo(break_line, startingHeight + 30)
          .stroke();
        doc.fontSize(p).moveDown();
        startingHeight = startingHeight + 40;

        doc.font('Helvetica').text(soilClassLabel, resultsYValue, startingHeight);
        doc.font('Helvetica-Bold').text('Site Soil Class: ', start, startingHeight);

        if (standardsVersion !== '41-17' && standardsVersion !== '41-23') {
          doc.text('Results: ', start, startingHeight + rowHeight);
        }

        if (standardsVersion === '7-22') {
          doc.addPage();
          doc
            .font('Helvetica-Bold')
            .text('Data Accessed: ', start, startingHeight + rowHeight)
            .text(dateAccessed.toDateString(), resultsYValue, startingHeight + rowHeight);
          doc
            .text('Date Source: ', start, startingHeight + rowHeight * 2)
            .text(`${standardsConfig[standardsVersion].dataSource}`);
        } else {
          // Based upon how many charts we have for the load, the content after needs to render appropriately
          let afterChartsMultiplier = 10;
          chartImages.forEach((image, idx) => {
            if (idx % 2 === 0) {
              afterChartsMultiplier += 13.5;
            }
          });

          if (standardsVersion === '41-17' || standardsVersion === '41-23') {
            const dataAccessedDateHeight = 700;
            console.log('log.test', dataAccessedDateHeight);
            doc
              .font('Helvetica-Bold')
              .text('Data Accessed: ', start, dataAccessedDateHeight)
              .text(dateAccessed.toDateString(), resultsYValue, dataAccessedDateHeight);
          } else {
            doc
              .font('Helvetica-Bold')
              .text('Data Accessed: ', start, startingHeight + rowHeight * afterChartsMultiplier)
              .text(dateAccessed.toDateString(), resultsYValue, startingHeight + rowHeight * afterChartsMultiplier);
            doc
              .text('Date Source: ', start, startingHeight + rowHeight * (afterChartsMultiplier + 1))
              .text(`${standardsConfig[standardsVersion].dataSource}`);
          }
        }
      }
      doc.font('Helvetica');
    }
  }, // end addSeismic

  addIce: (load, doc, startingHeight) => {
    let details = criteriaStore.getState();
    //   ==== Ice Loads ====
    doc.fontSize(h2).font('Helvetica-Bold').text(load.label, col_1_4, startingHeight).font('Helvetica');

    doc.lineWidth(1);
    doc
      .lineCap('butt')
      .moveTo(col_1_4, startingHeight + 20)
      .lineTo(break_line, startingHeight + 20)
      .stroke();

    doc.fontSize(p).moveDown();

    startingHeight = startingHeight + 30;
    doc
      .font('Helvetica-Bold')
      .text('Results: ', start, startingHeight)
      .text('Data Source: ', start, startingHeight + rowHeight * 4)
      .text('Date Accessed: ', start, startingHeight + rowHeight * 5)

      .font('Helvetica')
      .text('Ice Thickness: ', start + resultsIndent, startingHeight + rowHeight)
      .text(load.details[0].value, resultsYValue, startingHeight + rowHeight)

      .text('Concurrent Temperature: ', start + resultsIndent, startingHeight + rowHeight * 2)
      .text(load.details[1].value, resultsYValue, startingHeight + rowHeight * 2)
      .text(
        `${standardsConfig[details.standardsVersion].gustSpeed}`,
        start + resultsIndent,
        startingHeight + rowHeight * 3
      )
      .text(load.details[2].value, resultsYValue, startingHeight + rowHeight * 3)
      .text(
        'Standard ASCE/SEI ' + details.standardsVersion + ', Figs. 10-2 through 10-8',
        resultsYValue,
        startingHeight + rowHeight * 4
      )
      .text(dateAccessed.toDateString(), resultsYValue, startingHeight + rowHeight * 5)

      .text(
        'Ice thicknesses on structures in exposed locations at elevations higher than the surrounding terrain and in valleys and gorges may exceed the mapped values.',
        start,
        startingHeight + rowHeight * 6
      );
    let notesadded = 0;
    _.forEach(load.details, (detail) => {
      let noteHeight = rowHeight + notesadded * 2;
      if (detail.hasOwnProperty('note')) {
        if (typeof detail.note === 'string') {
          doc.text(detail.note, start, startingHeight + noteHeight * (8 + notesadded));
          notesadded++;
        } else {
          doc
            .text(detail.note.startingText, start, startingHeight + noteHeight * (8 + notesadded), { continued: true })
            .fillColor('#0645AD')
            .text(detail.note.hyperlinkText, {
              continued: true,
              link: detail.note.hyperlinkUrl,
              underline: true,
            })
            .fillColor('black')
            .text(detail.note.endingText, {
              continued: false,
              underline: false,
            });
          notesadded++;
        }
      }
    });
  }, // end addIce

  addSnow: (load, doc, startingHeight) => {
    let details = criteriaStore.getState();
    const { standardsVersion } = details;
    let hawaii = !!load.Hawaii;

    doc.fontSize(h2).font('Helvetica-Bold').text(load.label, col_1_4, startingHeight).font('Helvetica');

    doc.lineWidth(1);
    doc
      .lineCap('butt')
      .moveTo(col_1_4, startingHeight + 20)
      .lineTo(break_line, startingHeight + 20)
      .stroke();

    doc.fontSize(p).moveDown();

    startingHeight = startingHeight + 30;
    doc.font('Helvetica-Bold').text('Results: ', start, startingHeight).font('Helvetica');

    const isCaseStudy = _.includes(load.sampleData.value[0].toLowerCase(), 'case study');
    const stressDesignGround = load.details.find((detail) => detail.label === 'Ground Snow Loads for IRC only');
    const mri20 = load.details.find((detail) => detail.label === '20-year MRI Value');
    const wind = load.details.find((detail) => detail.label === 'Winter Wind Parameter');
    let heightMultiplier = 2;

    if (stressDesignGround) {
      resultsYValue = col_3_4 - 25;
    }

    if (isCaseStudy) {
      if (standardsVersion === '7-22') {
        if (wind) {
          doc.text(`${wind.label}: `, start + resultsIndent, startingHeight + rowHeight);
          doc.text(wind.value, resultsYValue, startingHeight + rowHeight);
        }
      }
      //  doc.text('Case Study Required', start + resultsIndent, startingHeight + rowHeight);
    } else {
      let pieces = load.details[0].value.split('^2');
      const widthOfValue = doc.widthOfString(pieces[0]);
      doc
        .text('Ground Snow Load, p  : ', start + resultsIndent, startingHeight + rowHeight)
        .text(pieces[0], resultsYValue, startingHeight + rowHeight);
      doc.fontSize(7).text('g', start + resultsIndent + 97, startingHeight + rowHeight + 5);
      if (pieces[0] !== 'No Information Available') {
        doc.fontSize(6).text('2', resultsYValue + widthOfValue, startingHeight + rowHeight - 5);
      }
      doc.fontSize(p);

      if (standardsVersion === '7-22') {
        if (mri20) {
          doc.text(`${mri20.label}: `, start + resultsIndent, startingHeight + rowHeight * heightMultiplier);
          doc.text(mri20.value, resultsYValue, startingHeight + rowHeight * heightMultiplier);
          heightMultiplier++;
        }

        if (wind) {
          doc.text(`${wind.label}: `, start + resultsIndent, startingHeight + rowHeight * heightMultiplier);
          doc.text(wind.value, resultsYValue, startingHeight + rowHeight * heightMultiplier);
          heightMultiplier++;
        }
      }
    }

    doc.text('Mapped Elevation: ', start + resultsIndent, startingHeight + rowHeight * heightMultiplier);

    let elevationValue = '';
    let extraLoadValues = 0;
    _.forEach(load.details, (detail, index) => {
      if (detail.label === 'Mapped Elevation') {
        elevationValue = detail.value;
      }
      if (index > 0 && detail.label === 'Load') {
        doc.text(detail.value, resultsYValue, startingHeight + rowHeight * (heightMultiplier + index));
        extraLoadValues++;
      }
    });

    const source = load.details.find((detail) => {
      return detail.type === 'dataSource';
    });
    const sourceText = typeof source === 'undefined' ? '' : source.dataSource.hyperlinkText;

    doc.text(elevationValue, resultsYValue, startingHeight + rowHeight * heightMultiplier);
    heightMultiplier++;
    doc
      .text('Data Source: ', start, startingHeight + (rowHeight * heightMultiplier + extraLoadValues))
      .text(sourceText, resultsYValue, startingHeight + (rowHeight * heightMultiplier + extraLoadValues));
    heightMultiplier++;
    doc
      .text('Date Accessed: ', start, startingHeight + (rowHeight * heightMultiplier + 2 + extraLoadValues))
      .text(
        dateAccessed.toDateString(),
        resultsYValue,
        startingHeight + (rowHeight * heightMultiplier + 2 + extraLoadValues)
      );

    if (_.includes(load.sampleData.value[0].toLowerCase(), 'case study')) {
      if (doc.x > start) {
        doc.moveTo(start, doc.y);
      }
      doc
        .moveDown()
        .text(
          'In "Case Study" areas, site-specific case studies are required to establish ground snow loads. Extreme local variations in ground snow loads in these areas preclude mapping at this scale.',
          start
        )
        .moveDown()
        .text(
          'Ground snow load determination for such sites shall be based on an extreme value statistical analysis of data available in the vicinity of the site using a value with a 2 percent annual probability of being exceeded (50-year mean recurrence interval).',
          start
        );
    }

    if (hawaii) {
      if (doc.x > start) {
        doc.moveTo(start, doc.y);
      }
      doc
        .moveDown()
        .text(
          'Snow loads are zero for Hawaii, except in mountainous regions as determined by the authority having jurisdiction.',
          start
        );
    }

    doc.moveTo(start, doc.y).moveDown();
    let currentY = doc.y;

    _.forEach(load.details, (detail) => {
      if (detail.hasOwnProperty('note')) {
        if (typeof detail.note === 'string') {
          doc.moveTo(start, doc.y).moveDown();
          if (detail.note.includes('Numbers in parentheses')) {
            currentY = fullReportBuilder.addTextToDoc(
              doc,
              'Values provided are ground snow loads. In areas designated "case study required," extreme local variations in ground snow loads preclude mapping at this scale. Site-specific case studies are required to establish ground snow loads at elevations not covered.',
              resultsYValue,
              currentY
            );

            currentY = currentY + rowHeight;
          } else {
            currentY = fullReportBuilder.addTextToDoc(doc, detail.note, resultsYValue, currentY);
            currentY = currentY + rowHeight;
          }
        } else {
          if (
            detail.note.hasOwnProperty('startingText') ||
            detail.note.hasOwnProperty('hyperlinkText') ||
            detail.note.hasOwnProperty('endingText')
          ) {
            doc
              .moveTo(start, currentY)
              .moveDown()
              .text(detail.note.startingText, { continued: true })
              .fillColor('#0645AD')
              .text(detail.note.hyperlinkText, {
                continued: true,
                link: detail.note.hyperlinkUrl,
                underline: true,
              })
              .fillColor('black')
              .text(detail.note.endingText, {
                continued: false,
                underline: false,
              });
          }
        }
      }
    });

    if (standardsVersion === '7-22') {
      if (stressDesignGround) {
        fullReportBuilder.addTextToDoc(doc, `${stressDesignGround.label}, p        :`, start, currentY);
        const widthOfString = doc.widthOfString(`${stressDesignGround.label}, p`);
        doc.fontSize(7).text('g(asd)', widthOfString + start, currentY + 5);
        doc.fontSize(p);

        let [value] = stressDesignGround.value.split('^2');
        if (value) {
          fullReportBuilder.addTextToDoc(doc, value, resultsYValue, currentY);
          const widthOfValue = doc.widthOfString(value);
          doc.fontSize(6).text('2', resultsYValue + widthOfValue, currentY - 5);
          doc.fontSize(p);
        } else {
          fullReportBuilder.addTextToDoc(doc, stressDesignGround.value, resultsYValue, currentY);
        }

        heightMultiplier++;
      }
    }
  }, // end addSnow

  addRain: (load, doc, startingHeight) => {
    doc.fontSize(h2).font('Helvetica-Bold').text(load.label, col_1_4, startingHeight).font('Helvetica');

    doc.lineWidth(1);
    doc
      .lineCap('butt')
      .moveTo(col_1_4, startingHeight + 20)
      .lineTo(break_line, startingHeight + 20)
      .stroke();

    doc.fontSize(p).moveDown();

    startingHeight = startingHeight + 30;

    if (load.details[0].value !== 'No Data') {
      doc
        .font('Helvetica-Bold')
        .text('Results: ', start, startingHeight)
        .text('Data Source: ', start, startingHeight + rowHeight * 5)
        .text('Date Accessed: ', start, startingHeight + rowHeight * 7)
        .font('Helvetica');

      doc
        .text('15-minute Precipitation Intensity: ', start + resultsIndent, startingHeight + rowHeight)
        .text(load.details[0].value, resultsYValue + 30, startingHeight + rowHeight)
        //  .text('Quantile: ', resultsYValue - 100, startingHeight + rowHeight * 2)
        //  .text('Lower: ', resultsYValue - 100, startingHeight + rowHeight * 3)
        //  .text('Upper: ', resultsYValue - 100, startingHeight + rowHeight * 4)
        //  .text(load.details[1].value, resultsYValue, startingHeight + rowHeight * 2)
        //  .text(load.details[2].value, resultsYValue, startingHeight + rowHeight * 3)
        //  .text(load.details[3].value, resultsYValue, startingHeight + rowHeight * 4)

        .text('60-minute Precipitation Intensity: ', start + resultsIndent, startingHeight + rowHeight * 3)
        .text(load.details[1].value, resultsYValue + 30, startingHeight + rowHeight * 3)
        //  .text('Quantile: ', resultsYValue - 100, startingHeight + rowHeight * 6)
        //  .text('Lower: ', resultsYValue - 100, startingHeight + rowHeight * 7)
        //  .text('Upper: ', resultsYValue - 100, startingHeight + rowHeight * 8)
        //  .text(load.details[5].value, resultsYValue, startingHeight + rowHeight * 6)
        //  .text(load.details[6].value, resultsYValue, startingHeight + rowHeight * 7)
        //  .text(load.details[7].value, resultsYValue, startingHeight + rowHeight * 8)

        .text(
          'NOAA National Weather Service, Precipitation Frequency Data Server, Atlas 14',
          resultsYValue,
          startingHeight + rowHeight * 5,
          { continued: true }
        )
        .fillColor('#0645AD')
        .text('(https://www.nws.noaa.gov/oh/hdsc/)', {
          link: 'https://www.nws.noaa.gov/oh/hdsc/',
          underline: true,
        })
        .fillColor('black')
        .text(dateAccessed.toDateString(), resultsYValue, startingHeight + rowHeight * 7);
    } else {
      doc
        .font('Helvetica-Bold')
        .text('Results: ', start, startingHeight)
        .text('Data Source: ', start, startingHeight + rowHeight * 3)
        .text('Date Accessed: ', start, startingHeight + rowHeight * 5)
        .font('Helvetica');

      doc
        .text('15-minute duration: ', start + resultsIndent, startingHeight + rowHeight)
        .text('No Data', resultsYValue, startingHeight + rowHeight)
        .text('60-minute duration: ', start + resultsIndent, startingHeight + rowHeight * 2)
        .text('No Data', resultsYValue, startingHeight + rowHeight * 2)
        .text(
          'NOAA National Weather Service, Precipitation Frequency Data Server, Atlas 14',
          resultsYValue,
          startingHeight + rowHeight * 3,
          { continued: true }
        )
        .fillColor('#0645AD')
        .text('(https://www.nws.noaa.gov/oh/hdsc/)', {
          link: 'https://www.nws.noaa.gov/oh/hdsc/',
          underline: true,
        })
        .fillColor('black')
        .text(dateAccessed.toDateString(), resultsYValue, startingHeight + rowHeight * 5);
      if (typeof load.details[1] === 'object') {
        doc
          .moveDown()
          .text(load.details[1].note.startingText, { continued: true })
          .fillColor('#0645AD')
          .text(load.details[1].note.hyperlinkText, {
            continued: true,
            link: load.details[1].note.hyperlinkUrl,
            underline: true,
          })
          .fillColor('black')
          .text(load.details[1].note.endingText, {
            continued: false,
            underline: false,
          });
      }
    }
  }, // end addRain

  addWind: (load, doc, startingHeight) => {
    const { standardsVersion } = criteriaStore.getState();
    // load section header
    doc.fontSize(h2).font('Helvetica-Bold').text(load.label, col_1_4, startingHeight).font('Helvetica');
    doc.lineWidth(1);
    doc
      .lineCap('butt')
      .moveTo(col_1_4, startingHeight + 20)
      .lineTo(break_line, startingHeight + 20)
      .stroke();
    doc.fontSize(p).moveDown();
    startingHeight = startingHeight + 30;
    // begin load details
    doc.font('Helvetica-Bold').text('Results: ', start, startingHeight);
    doc.font('Helvetica');

    const special = load.details.find((detail) => {
      return detail.label === 'Special';
    });
    const loadSource = load.details.find((d) => d.type === 'dataSource');

    // let newStartingRow = 0;
    startingHeight += rowHeight + 4;

    if (standardsVersion === '7-22' && load.isIslandTerritory) {
      const mri = load.details.find((detail) => {
        return detail.label === '10,000-year MRI';
      });
      if (mri) {
        fullReportBuilder.addTextToDoc(doc, mri.label, start + resultsIndent, startingHeight);
        startingHeight = 4 + fullReportBuilder.addTextToDoc(doc, mri.value, resultsYValue, startingHeight);
      }
    } else {
      load.details.forEach((detail) => {
        if (detail.type === 'singleLine' && detail.value && detail.label.toLowerCase() !== 'special') {
          fullReportBuilder.addTextToDoc(doc.font('Helvetica'), detail.label, start + resultsIndent, startingHeight);
          startingHeight = 4 + fullReportBuilder.addTextToDoc(doc, detail.value, resultsYValue, startingHeight);
        }
      });
    }

    if (special) {
      fullReportBuilder.addTextToDoc(doc, special.label, start + resultsIndent, startingHeight);
      startingHeight = rowHeight + fullReportBuilder.addTextToDoc(doc, special.value, resultsYValue, startingHeight);
    }

    startingHeight += rowHeight;

    fullReportBuilder.addTextToDoc(doc, 'Data Source: ', start, startingHeight);
    startingHeight =
      4 + fullReportBuilder.addTextToDoc(doc, loadSource.dataSource.hyperlinkText, resultsYValue, startingHeight);

    fullReportBuilder.addTextToDoc(doc, 'Date Accessed: ', start, startingHeight);
    startingHeight =
      8 + fullReportBuilder.addTextToDoc(doc, dateAccessed.toDateString(), resultsYValue, startingHeight);

    // add wind notes
    const notes = load.details.filter((d) => d.type === 'note');

    notes.forEach((n) => {
      startingHeight = 4 + fullReportBuilder.addTextToDoc(doc, n.note, start, startingHeight);
    });

    return startingHeight;
    // doc
    //   .moveDown()
    //   .text(
    //     'Mountainous terrain, gorges, ocean promontories, and special wind regions should be examined for unusual wind conditions.',
    //     start
    //   );
  }, // end addWind

  addFlood: (load, doc, startingHeight) => {
    //   ==== Flood Loads ====
    doc.fontSize(h2).font('Helvetica-Bold').text(load.label, col_1_4, startingHeight).font('Helvetica');

    doc.lineWidth(1);
    doc
      .lineCap('butt')
      .moveTo(col_1_4, startingHeight + 20)
      .lineTo(break_line, startingHeight + 20)
      .stroke();

    doc.fontSize(p).moveDown();

    startingHeight = startingHeight + 30;
    doc
      .font('Helvetica-Bold')
      .text('Results: ', start, startingHeight)
      .text('Data Source: ', start, startingHeight + rowHeight * 5)
      .text('Date Accessed: ', start, startingHeight + rowHeight * 7)
      .text('FIRM Panel: ', start, startingHeight + rowHeight * 8)
      .text('Insurance Study Note: ', start, startingHeight + rowHeight * 9)

      .font('Helvetica')
      .text('Flood Zone Categorization: ', start + resultsIndent, startingHeight + rowHeight)
      .text(load.details[0].value, resultsYValue, startingHeight + rowHeight)
      .text('Base Flood Elevation: ', start + resultsIndent, startingHeight + rowHeight * 3)
      .text(load.details[1].value, resultsYValue, startingHeight + rowHeight * 3)
      .text(
        'FEMA National Flood Hazard Layer - Effective Flood Hazard Layer for US, where modernized ',
        resultsYValue,
        startingHeight + rowHeight * 5,
        { continued: true }
      )
      .fillColor('#0645AD')
      .text('(https://msc.fema.gov/portal/search)', {
        link: 'https://msc.fema.gov/portal/search',
        underline: true,
      })
      .fillColor('black')
      .text(dateAccessed.toDateString(), resultsYValue, startingHeight + rowHeight * 7)
      .text('If available, download FIRM panel ', resultsYValue, startingHeight + rowHeight * 8, { continued: true })
      .fillColor('#0645AD')
      .text('here', { link: load.details[3].hyperlinkUrl, underline: true })
      .fillColor('black')
      .text('Download FEMA Flood Insurance Study for this area ', resultsYValue, startingHeight + rowHeight * 9, {
        continued: true,
      })
      .fillColor('#0645AD')
      .text('here', { link: load.details[3].hyperlinkUrl, underline: true })
      .fillColor('black');

    if (floodMap === '') {
      reportActions.showReportBuildPopup(
        'Due to connectivity issues at the FEMA website, flood map images are unavailable for the PDF report. The report will continue to build with basic flood data but no images.'
      );
      // doc
      //   .fillColor('red')
      //   .text(
      //     'Image temporarily unavailable due to',
      //     start + 30,
      //     startingHeight + rowHeight * 8 + 60
      //   );
      // doc
      //   .text(
      //     'connection difficulties with FEMA website.',
      //     start + 30,
      //     startingHeight + rowHeight * 8 + 70
      //   )
      //   .fillColor('black');
    } else {
      doc.image(floodMap, start, startingHeight + rowHeight * 8 + 30, {
        width: width_map,
      });
      doc.rect(start, startingHeight + rowHeight * 8 + 30, width_map, 250).stroke();
    }
  }, // end addFlood

  addTsunami: (load, doc, startingHeight) => {
    doc.fontSize(h2).font('Helvetica-Bold').text(load.label, col_1_4, startingHeight).font('Helvetica');

    doc.lineWidth(1);
    doc
      .lineCap('butt')
      .moveTo(col_1_4, startingHeight + 20)
      .lineTo(break_line, startingHeight + 20)
      .stroke();

    doc.fontSize(p).moveDown();

    startingHeight = startingHeight + 30;
    doc
      .font('Helvetica-Bold')
      .text('Results: ', start, startingHeight)
      .text('Data Source: ', start, startingHeight + rowHeight * 3)
      .text('Date Accessed: ', start, startingHeight + rowHeight * 4)

      .font('Helvetica')
      .text('Tsunami: ', start + resultsIndent, startingHeight + rowHeight)
      .text(
        typeof load.details[0].value === 'undefined'
          ? 'In mapped tsunami design zone. Go to https://asce7tsunami.online/ for more information.'
          : load.details[0].value,
        resultsYValue,
        startingHeight + rowHeight
      )
      .fillColor('#0645AD')
      .text('ASCE Tsunami Design Geodatabase', resultsYValue, startingHeight + rowHeight * 3, {
        link: 'http://asce7tsunami.online',
        underline: true,
      })
      .fillColor('black')
      .text(dateAccessed.toDateString(), resultsYValue, startingHeight + rowHeight * 4);
  }, // end addTsunami

  addTornado: (load, doc, startingHeight) => {
    doc.fontSize(h2).font('Helvetica-Bold').text(load.label, col_1_4, startingHeight).font('Helvetica');

    doc.lineWidth(1);
    doc
      .lineCap('butt')
      .moveTo(col_1_4, startingHeight + 20)
      .lineTo(break_line, startingHeight + 20)
      .stroke();

    doc.fontSize(p).moveDown();

    startingHeight = startingHeight + 30;
    doc.text('Results: ', start, startingHeight);

    if (tornadoTable.length > 0) {
      doc.image(tornadoTable, start, startingHeight + rowHeight, { width: report_row_1 });
      doc
        .addPage()
        .font('Helvetica-Bold')
        .text('Data Source: ', start, startingHeight + rowHeight)
        .font('Helvetica')
        // .fillColor('#0645AD')
        .text(
          'ASCE/SEI Standard 7-22, Figs. 32.5-1, 32.5-2, and G.2-1 through -4',
          resultsYValue,
          startingHeight + rowHeight
        );
      doc
        .font('Helvetica-Bold')
        .text('Date Accessed: ', start, startingHeight + rowHeight * 2)
        .font('Helvetica')
        .text(dateAccessed.toDateString(), resultsYValue, startingHeight + rowHeight * 2);
    } else {
      doc.text(load.details[0].value, start, startingHeight + rowHeight);
    }
  }, // end addTornado

  addCharts: (doc, startingHeight, charts, load) => {
    let standardsVersion = criteriaStore.getState().standardsVersion;

    const newStartingHeight = startingHeight + 10;
    const details = load.details.filter((detail) => detail.type === 'chart');
    let multiplier = 13;
    charts.forEach((chart, idx) => {
      // How to position y
      if (idx % 2 === 0 && idx !== 0) {
        multiplier += 13;
      }
      let x = idx % 2 === 0 && charts.length !== 1 ? col_2_2 : start;
      const y = newStartingHeight + rowHeight * multiplier;

      const title = details[idx].title;
      const hasMCER = title.indexOf('MCER') >= 0 ? true : false;
      const title2 = hasMCER ? title.replace('R', '  ') : title;
      // Append Chart title
      if (title2.length > 37) {
        doc.text(title2, x + 10, y, { width: width_map });
      } else {
        doc.text(title2, x + 75, y, { width: width_map });
      }

      // Append subscript for MCER text
      if (hasMCER) {
        doc.fontSize(7);
        if (standardsVersion === '7-22') {
          let rSpacing = title.indexOf('R') > 3 ? 153 : 96;
          doc.text('R', x + rSpacing, y + 3);
        } else {
          doc.text('R', x + 97, y + 3);
        }
        doc.fontSize(p);
      }
      // Append chart
      if (standardsVersion === '7-22') {
        if (details[idx].data.length === 0) {
          doc.text('Vertical ground motion data has not yet been made available by USGS.', x, y + 15, {
            width: width_map,
          });
          return;
        } else {
          doc.image(chart, x, y + 5, { width: width_map });
        }
      } else {
        doc.image(chart, x, y + 5, { width: width_map });
      }
      // Append Axes label
      doc.fontSize(9);
      doc.text('S  (g) vs T(s)', x + 75, y + 150, { width: width_map });
      // Append subscript for axes label
      doc.fontSize(7);
      doc.text('a', x + 81, y + 153);
      doc.fontSize(p);
    });
  }, // addCharts

  getLoadChartImages: (load) => {
    let standardsVersion = criteriaStore.getState().standardsVersion;

    // Full Report Charts
    const canvasHeight = 1500;
    const canvasWidth = 900;
    const canvasZIndex = 8;
    const canvasContainer = document.getElementById('seismicPrintChart');
    const canvas = document.createElement('canvas');
    canvas.id = 'designSpectrum';
    canvas.width = canvasHeight;
    canvas.height = canvasWidth;
    canvas.style.zIndex = canvasZIndex;

    const ctx = canvas.getContext('2d');

    // Turn off legend
    window.Chart.defaults.global.legend.display = false;
    const dataConfig = {
      backgroundColor: 'rgba(255, 102, 102, 0.4)',
      borderColor: 'rgba(255, 102, 102, 0.4)',
      pointBackgroundColor: 'rgba(255, 102, 102, 1)',
      pointBorderColor: 'rgba(255, 102, 102, 1)',
      showLine: true,
    };
    // Filter load details to get charts
    const charts = load.details.filter((detail) => detail.type === 'chart');
    const loadChartImages = [];
    // For each chart detail, render the chart on canvas to get base64 image - then remove from canvas
    charts.map((chart) => {
      canvasContainer.appendChild(canvas);

      const scatterChart = new window.Chart(ctx, {
        type: 'scatter',
        data: {
          datasets: [
            {
              label: chart.title,
              data: chart.data,
              ...dataConfig,
            },
          ],
        },
      });

      scatterChart.draw();
      loadChartImages.push(scatterChart.toBase64Image());
      canvasContainer.removeChild(canvas);
    });

    // Return the array of base64 images
    return loadChartImages;
  }, // end getLoadChartImages
}; // end fullReportBuilder

export const buildReport = fullReportBuilder.buildReport;
